export default __webpack_public_path__ + "static/media/erp_banner.662ec52a.png";